export default __webpack_public_path__ + "static/media/LimitExhausted.54041160.svg";